import { useTranslation } from 'react-i18next';
import { ArrowUpRight } from 'lucide-react';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="border-t border-border bg-muted/40">
      <div className="section-container py-8">
        <div className="flex items-center gap-2.5 mb-4">
          <div className="h-6 w-6 rounded-full border-[1.5px] border-primary flex items-center justify-center">
            <ArrowUpRight className="h-3 w-3 text-primary" />
          </div>
          <span className="text-[13px] font-bold text-foreground tracking-[0.08em] uppercase">ORION</span>
        </div>
        <p className="text-[11px] leading-relaxed text-muted-foreground max-w-3xl mb-4">{t('footer.disclaimer')}</p>
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-[11px] text-muted-foreground">Orion Predict © 2026</p>
          <div className="flex gap-5 text-[11px] text-muted-foreground">
            <a href="#" className="hover:text-foreground transition-colors">{t('footer.terms')}</a>
            <a href="#" className="hover:text-foreground transition-colors">{t('footer.privacy')}</a>
            <a href="#" className="hover:text-foreground transition-colors">{t('footer.docs')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
